import { useTranslation } from "react-i18next";
import "../styles/styles.scss";
import "../styles/Fuerteventura.scss";
function Fuerteventura() {
  const { t } = useTranslation();

  return (
    <div className="island-container">
      <div>
        <div className="island-info">
          Fuerteventura – Rajska Wyspa Kanaryjska
        </div>
        <div>
          Fuerteventura, jedna z najbardziej urokliwych wysp archipelagu Wysp
          Kanaryjskich, to raj dla miłośników natury, sportów wodnych i relaksu.
          Znana ze swoich złocistych plaż, turkusowych wód oraz wyjątkowego
          klimatu, Fuerteventura przyciąga turystów przez cały rok. Co sprawia,
          że ta wyspa wciąż zyskuje na popularności.
        </div>
      </div>
      <div>
        <div className="island-info">
          Fuerteventura – Najważniejsze informacje
        </div>
        <div>
          Fuerteventura, druga co do wielkości wyspa Kanarów, jest położona na
          Oceanie Atlantyckim, zaledwie 100 km od wybrzeży Afryki. Dzięki temu
          wyspa cieszy się wyjątkowym, słonecznym klimatem przez cały rok, z
          minimalną ilością opadów, co czyni ją idealnym miejscem na wakacje o
          każdej porze roku.
        </div>
      </div>
      <div>
        <div className="island-info">Pogoda na Fuerteventurze</div>
        <div>
          Fuerteventura to także coraz bardziej rozwijająca się infrastruktura
          turystyczna. Wyspa oferuje szeroki wybór apartamentów oraz luksusowych
          resortów, które czekają na przyjęcie turystów spragnionych słońca i
          relaksu.
        </div>
        <div>
          Wyspa zyskuje również na popularności dzięki licznym połączeniom
          lotniczym z Europą – wiele tanich linii lotniczych planuje uruchomić
          nowe trasy na Fuerteventurę, co sprawi, że podróż będzie jeszcze
          bardziej dostępna.
        </div>
      </div>
      <div>
        <div className="island-info">
          Odkryj Fuerteventurę i zakochaj się w jej naturalnym pięknie!{" "}
        </div>
        <div>
          Fuerteventura to wyspa, którą pokochasz za jej dzikie krajobrazy,
          przyjaznych mieszkańców i niepowtarzalną atmosferę. Niezależnie od
          tego, czy szukasz aktywnego wypoczynku, czy relaksu na plaży,
          Fuerteventura ma coś dla każdego.{" "}
        </div>
      </div>
      <div>
        <div className="island-info">
          Historia Fuerteventury – Od starożytnych cywilizacji po nowoczesny raj
          turystyczny
        </div>
        <div>
          Fuerteventura, najstarsza z Wysp Kanaryjskich, skrywa w sobie
          fascynującą historię, która sięga tysięcy lat wstecz. Dziś to
          popularne miejsce wypoczynku, ale jej przeszłość jest równie
          interesująca, co współczesne atrakcje. Jeśli planujesz wakacje na tej
          wyspie w 2024 roku, warto poznać jej bogate dziedzictwo i zrozumieć,
          jak kształtowała się przez wieki.
        </div>
      </div>
      <div>
        <div className="island-info">
          Początki osadnictwa – starożytne cywilizacje
        </div>
        <div>
          Pierwsze ślady osadnictwa na Fuerteventurze sięgają około 2000 roku
          p.n.e., kiedy to pierwsi mieszkańcy, znani jako Majos lub Mahos,
          przybyli na wyspę z Afryki Północnej. Byli to ludzie prowadzący
          osiadły tryb życia, trudniący się rolnictwem, rybołówstwem i hodowlą.
          Mimo iż ich wiedza o nawigacji była ograniczona, Majos potrafili
          przetrwać w surowych warunkach Fuerteventury, wykorzystując minimalne
          zasoby wyspy.
        </div>
      </div>
      <div>
        <div className="island-info">
          Podbój hiszpański – powstanie Betancurii
        </div>
        <div>
          Kluczowym momentem w historii Fuerteventury było jej podbicie przez
          Hiszpanów w XV wieku. W 1404 roku Jean de Béthencourt, francuski
          rycerz na służbie korony kastylijskiej, zorganizował wyprawę na Wyspy
          Kanaryjskie, zdobywając Fuerteventurę i Lanzarote. To Béthencourt
          założył pierwszą stolicę wyspy – Betancurię, która przez długi czas
          była centrum administracyjnym i religijnym wyspy.
        </div>
        <div>
          Betancuria, choć dzisiaj niewielkie miasteczko, zachowała wiele ze
          swojej kolonialnej historii. Spacerując po jej uliczkach, można
          zobaczyć Iglesia de Santa María, pierwszą katedrę na wyspie, a także
          zabytkowe domy przypominające o hiszpańskim dziedzictwie.
        </div>
      </div>
      <div>
        <div className="island-info">Era piratów i najazdów</div>
        <div>
          W XVII i XVIII wieku Fuerteventura, podobnie jak inne wyspy
          Kanaryjskie, była narażona na liczne ataki piratów. Najbardziej znanym
          epizodem w tej części historii był atak pirata Johana van Hoorn w 1740
          roku. Najazdy często prowadziły do zniszczeń, ale wyspa zawsze się
          odbudowywała, co pokazuje hart ducha jej mieszkańców.
        </div>
      </div>
      <div>
        <div className="island-info">XIX wiek – integracja z Hiszpanią</div>
        <div>
          W XIX wieku, po wielu latach kolonialnej dominacji, Wyspy Kanaryjskie,
          w tym Fuerteventura, zostały w pełni zintegrowane z Hiszpanią jako
          część jej prowincji. Fuerteventura, choć odizolowana od kontynentu,
          zaczęła się rozwijać gospodarczo, głównie dzięki rolnictwu, hodowli
          kóz oraz produkcji sera Majorero, który zyskał popularność na całym
          świecie.
        </div>
      </div>
      <div>
        <div className="island-info">XX wiek – droga do nowoczesności</div>
        <div>
          XX wiek przyniósł Fuerteventurze kolejne zmiany. Z czasem rolnictwo
          przestało być głównym źródłem utrzymania, a wyspa zaczęła stawiać na
          turystykę. Dzięki swojemu wyjątkowemu klimatowi, wspaniałym plażom i
          szerokiej ofercie sportów wodnych, Fuerteventura stała się jednym z
          ulubionych kierunków wakacyjnych w Europie. Wyspa przyciąga turystów
          nie tylko swoimi naturalnymi walorami, ale także bogatą historią,
          którą można odkrywać na każdym kroku. Coraz więcej podróżników szuka
          autentycznych doświadczeń, a turystyka historyczna staje się jednym z
          głównych trendów.
        </div>
        <div>
          Odwiedzając Fuerteventurę, warto nie tylko korzystać z jej pięknych
          plaż, ale także poznać dziedzictwo Majos, historię kolonialną w
          Betancurii czy tajemnice najazdów pirackich. Zamek w Caleta de Fuste
          oraz muzea w Puerto del Rosario to idealne miejsca, by zanurzyć się w
          fascynującą historię tej wyjątkowej wyspy.
        </div>
      </div>
      <div>
        <div className="island-info">
          Dlaczego historia Fuerteventury jest ważna dla współczesnych turystów?{" "}
        </div>
        <ol>
          <li>
            Kultura i dziedzictwo – Fuerteventura to nie tylko słońce i plaże.
            To także wyspa z unikatową historią, która kształtowała jej
            współczesny charakter.
          </li>
          <li>
            Autentyczne doświadczenia – Poznanie historii wyspy pozwala lepiej
            zrozumieć jej kulturę, tradycje i ludzi.
          </li>
          <li>
            Odkrywanie nieznanych miejsc – Historia Fuerteventury kryje w sobie
            wiele tajemnic, które czekają na odkrycie przez ciekawych turystów.
          </li>
        </ol>
      </div>
      <div>
        <div className="island-info">
          Odkryj historię Fuerteventury już dziś!{" "}
        </div>
        <div>
          Fuerteventura to miejsce, gdzie historia spotyka się z nowoczesnością.
          Od starożytnych osadników po współczesnych turystów, wyspa ta zawsze
          była miejscem, które fascynuje i inspiruje. Odwiedź Fuerteventurę i
          poznaj jej niezwykłą historię.
        </div>
      </div>
    </div>
  );
}

export default Fuerteventura;
